var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 3.83334H6.25C5.91848 3.83334 5.60054 3.96504 5.36612 4.19946C5.1317 4.43388 5 4.75182 5 5.08334V15.0833C5 15.4149 5.1317 15.7328 5.36612 15.9672C5.60054 16.2016 5.91848 16.3333 6.25 16.3333H13.75C14.0815 16.3333 14.3995 16.2016 14.6339 15.9672C14.8683 15.7328 15 15.4149 15 15.0833V8.20834L10.625 3.83334Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.83334V8.83334H14.9999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.707 10.8762C15.3165 10.4857 14.6833 10.4857 14.2928 10.8762M15.707 10.8762H14.2928M15.707 10.8762L17.3737 12.5429C17.7642 12.9334 17.7642 13.5666 17.3737 13.9571C16.9964 14.3344 16.3926 14.3472 15.9999 13.9954L15.9999 15.3333C15.9999 15.8856 15.5522 16.3333 14.9999 16.3333C14.4476 16.3333 13.9999 15.8856 13.9999 15.3333L13.9999 13.9954C13.6073 14.3472 13.0035 14.3344 12.6261 13.9571C12.2356 13.5666 12.2356 12.9334 12.6261 12.5429L14.2928 10.8762M15.707 10.8762H14.2928M13.0833 15.3333C13.0833 14.7811 12.6355 14.3333 12.0833 14.3333C11.531 14.3333 11.0833 14.7811 11.0833 15.3333V16.7222C11.0833 17.1501 11.2412 17.5733 11.542 17.8956C11.8448 18.22 12.271 18.4167 12.7314 18.4167H17.2684C17.7289 18.4167 18.155 18.22 18.4578 17.8956C18.7586 17.5733 18.9166 17.1501 18.9166 16.7222V15.3333C18.9166 14.7811 18.4689 14.3333 17.9166 14.3333C17.3643 14.3333 16.9166 14.7811 16.9166 15.3333V16.4167H13.0833V15.3333Z",
    fill: "currentColor",
    stroke: "#E9F8F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploaded);
export default __webpack_public_path__ + "static/media/icon-uploaded.f956a7d76c36af94e48539aa03bc78d0.svg";
export { ForwardRef as ReactComponent };